export const MinScrollTableColumn = 9

export const ItemsColumn = {
    Id: 'id',
    No: 'No',
    STT: 'STT',
    NoD: 'No.', // BootstrapTable cannot map '.'
    OrderNumber: 'Order Number',
    Description: 'Description',
    AmountWithoutVAT: 'Amount Without VAT'
}

export const DefaultInvoiceItemsMasterView = [
    {
      "name": "Order Number",
      "show": false,
      "required": null,
      "type": "String",
      "format": null,
      "length": 15,
      "mass_update_view": null,
      "mass_update": null,
      "default_order": 1,
      "items": true
    },
    {
      "name": "Description",
      "show": false,
      "required": null,
      "type": "String",
      "format": null,
      "length": 255,
      "mass_update_view": null,
      "mass_update": null,
      "default_order": 2,
      "items": true
    },
    {
      "name": "Unit",
      "show": false,
      "required": null,
      "type": "String",
      "format": null,
      "length": 15,
      "mass_update_view": null,
      "mass_update": null,
      "default_order": 3,
      "items": true
    },
    {
      "name": "Quantity",
      "show": false,
      "required": null,
      "type": "Decimal",
      "format": null,
      "length": null,
      "mass_update_view": null,
      "mass_update": null,
      "default_order": 4,
      "items": true
    },
    {
      "name": "Unit Price",
      "show": false,
      "required": null,
      "type": "Decimal",
      "format": null,
      "length": null,
      "mass_update_view": null,
      "mass_update": null,
      "default_order": 5,
      "items": true
    },
    {
      "name": "Amount Without VAT",
      "show": false,
      "required": null,
      "type": "Decimal",
      "format": null,
      "length": null,
      "mass_update_view": null,
      "mass_update": null,
      "default_order": 6,
      "items": true
    },
    {
      "name": "VAT Rate",
      "show": false,
      "required": null,
      "type": "Int",
      "format": null,
      "length": null,
      "mass_update_view": null,
      "mass_update": null,
      "default_order": 7,
      "items": true
    }
]